import React from 'react';
import PropTypes from 'prop-types';
import { formatPosition, resultHref } from 'modules/HorseRacing/utils';
import {LocalFullDateShort} from 'modules/Common/components/LocalDateTime';
import CaretLink from 'modules/Common/components/CaretLink';
import {Link} from 'react-router';

export default function HorseRacingFormTable({horse, results}) {

    if (!results || results.length === 0) {
        return null;
    }

    function renderResult(result) {
        const {
            course_name = "Unknown",
            race_id,
            date,
            distance,
            run_type,
            weight
            } = result;

        return (
            <tr key={race_id}>
                <td>
                <Link to={resultHref(result)}
                    className="hr-racing-runner-form-racecard-link">
                    <LocalFullDateShort iso={date}/>
                </Link>
                </td>
                <td>{course_name}</td>
                <td>{distance}</td>
                <td>{run_type}</td>
                <td>{weight}</td>
                <td>{formatPosition(result, {showRunnerCount: false})}</td>
            </tr>
        );
    }

    return (
        <div className="hr-racing-runner-form-table">
            <table className="default-table">
            <thead>
                <tr>
                    <th>Date</th>
                    <th>CRS</th>
                    <th>Dist</th>
                    <th>Type</th>
                    <th>WGT</th>
                    <th>Pos</th>
                </tr>
            </thead>
            <tbody>
                {results.map(result => renderResult(result))}
            </tbody>
            </table>
            <CaretLink className="hr-racing-runner-form-lifetime-link" to={`/racing/profiles/horse/${horse.horse_reference.id}`} caretDirection="right">See lifetime form</CaretLink>
        </div>
    );
}

HorseRacingFormTable.propTypes = {
    horse: PropTypes.object.isRequired,
    results: PropTypes.array.isRequired
}


// WEBPACK FOOTER //
// ./modules/HorseRacing/components/HorseRacingFormTable.js